import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    skipNavLink: {
        fontFamily: 'FuturaStd, Arial',
        fontSize: "1.5rem",
        position: "absolute",
        left: "-1000px",
        '&:focus': {
            left: "0",
            width: "100%",
            padding: "0 0.25rem",
            position: "relative"
        }
    },
}));
